import styled from 'styled-components/macro';
import { RadioButton } from '@yme/atoms/radio-button';
import { colorCoreGray500 } from '@yme/tokens/colors';
export const RadioButtonGroupStyled = styled.div `
  border-radius: 6px;
  border: 1px solid ${colorCoreGray500};

  & div:last-child {
    border-top: 1px solid ${colorCoreGray500};
  }

  ${({ isDifferentAddressOption }) => isDifferentAddressOption &&
    `
    border-style: solid solid none solid;
    border-radius: 6px 6px 0 0;
  `}
`;
export const RadioButtonStyled = styled(RadioButton) `
  padding: 18px;
`;
export const DifferentAddressSectionStyled = styled.div `
  background: #fafafa;
  padding: 16px 20px 20px 20px;
  border: 1px solid ${colorCoreGray500};
  border-radius: 0 0 6px 6px;
`;
